import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/es';

export const SPAIN_TIMEZONE = 'Europe/Madrid';
/** Format the backend expects: wall clock without timezone */
export const BACKEND_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('es');

/** Any date -> dayjs positioned on the Spanish wall clock */
export const toSpanishTime = (value?: string | Date | null) =>
  (value ? dayjs(value) : dayjs()).tz(SPAIN_TIMEZONE);

const WALL_CLOCK = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/;

/**
 * Spanish wall clock -> 'YYYY-MM-DDTHH:mm:ss' string sent to the backend.
 * Idempotent: a value that is already a wall clock is returned untouched.
 */
export const toBackendDate = (value?: string | Date | null) => {
  if (typeof value === 'string' && WALL_CLOCK.test(value)) {
    return value.length === 16 ? `${value}:00` : value;
  }

  return toSpanishTime(value).format(BACKEND_DATE_FORMAT);
};

export default dayjs;
